import { buttonVariants } from "@/components/ui/button/button";
import { Link, useLoaderData } from "@tanstack/react-router";
import { HelpCircle } from "lucide-react";

const HelpWithSetupCard = () => {
	const { name } = useLoaderData({
		from: "__root__",
	});
	return (
		<div className="mb-6 flex flex-col rounded-2xl border border-gray-200 bg-primary-50/50 p-5">
			<div className="flex gap-4">
				<div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-primary-100">
					<HelpCircle className="size-5 text-primary-600" />
				</div>
				<div className="min-w-0 flex-1">
					<h3 className="font-semibold text-textDark">Complete your setup</h3>
					<p className="mt-1 text-sm text-textDark">
						Get step-by-step guidance to complete your {name} account setup.
					</p>
				</div>
			</div>
			<Link
				to="/main/onboarding"
				className={buttonVariants({
					variant: "secondary",
					size: "lg",
					className: "mt-4 w-full",
				})}
			>
				Get started
			</Link>
		</div>
	);
};

export default HelpWithSetupCard;
